<div>    
    <button     *ngIf   =   "action != 'create'"
                type    =   "button" 
                class   =   "btn btn-outline-secondary mr-3 mb-3" 
                (click) =   "create()" 
                translate>
        device.action.create
    </button>
    
    <ng-container *ngIf="deviceDetail && deviceDetail.id">
    
        <ng-container *ngIf = "action != 'create'">
            <button type="button" class="btn btn-outline-secondary mr-3 mb-3" (click) = "clone()"  translate>device.action.clone</button>
        </ng-container>
        <ng-container *ngIf = "action != 'create'">
            <button type="button" class="btn btn-outline-secondary mr-3 mb-3" (click) = "activation()"  translate>device.action.activation</button>
        </ng-container>
        <ng-container *ngIf = "action != 'create' && deviceDetail?.id && deviceDetail?.type == 20">
            <button type="button" class="btn btn-outline-secondary mr-3 mb-3" (click) = "assignOperator()"  translate>device.action.goToassignOperator</button>
        </ng-container>

    </ng-container>
</div>

<div *ngIf = "deviceDetail || action == 'create'" class = "card">
    
    <div class = "card-header">
        <span translate>device.name.info</span>

        <ng-container [ngSwitch]="deviceDetail.type">
            <ng-container *ngSwitchCase="10"><span translate>device.name.codino</span></ng-container>
            <ng-container *ngSwitchCase="20"><span translate>device.name.counter</span></ng-container>
            <ng-container *ngSwitchCase="30"><span translate>device.name.summary</span></ng-container>
            <ng-container *ngSwitchDefault></ng-container>
        </ng-container>
    </div>

    <div class = "card-body">

        <!-- ------------------------------------------------------------------------  -->

        <ng-container *ngIf = "action == 'create'">

            <custom-select  #deviceType
                            autoSelectFirst   = "true"
                            title_multiple    = "device.field.types"
                            [values]          = "types"
                            class             = "full-width"
                            (change)          = "typeChange($event)">
            </custom-select>

        </ng-container>

        <div class="row " *ngIf="false"> <!-- action == 'update' -->
            <!-- Summary Logo -->
            <cq-file    *ngIf="deviceDetail.type == 30"
                        class           =   "m-auto"
                        label           =   "Logo"
                        [formCtrl]      =   "logo"
                        [validators]    =   "logo_validators"
                        appearance      =   "outline"
                        [destination]   =   "getDest('SUMM', 'LOGO')"></cq-file>
            <!-- Codino Logo -->
            <cq-file    *ngIf="deviceDetail.type == 10"
                        class           =   "m-auto"
                        label           =   "Logo"
                        [formCtrl]      =   "logo"
                        [validators]    =   "logo_validators"
                        appearance      =   "outline"
                        [destination]   =   "getDest('CODI', 'LOGO')"></cq-file>
            <!-- Codino Background -->
            <cq-file    *ngIf="deviceDetail.type == 10"
                        class           =   "m-auto"
                        label           =   "Background Image"
                        [formCtrl]      =   "logo"
                        [validators]    =   "ticket_validators"
                        appearance      =   "outline"
                        [destination]   =   "getDest('CODI', 'BACK')"></cq-file>
            <!-- Codino Ticket Logo -->
            <cq-file    *ngIf="deviceDetail.type == 10"
                        class           =   "m-auto"
                        label           =   "Ticket Logo"
                        [formCtrl]      =   "logo"
                        [validators]    =   "logo_validators"
                        appearance      =   "outline"
                        [destination]   =   "getDest('TICK', 'LOGO')"></cq-file>


        </div>

        <!-- ------------------------------------------------------------------------  -->

            <mat-form-field class = "full-width">
                <mat-label translate>device.field.deviceName</mat-label>
                <input [(ngModel)]="deviceDetail.deviceName" matInput>
            </mat-form-field>

        <!-- ------------------------------------------------------------------------  -->

        <ng-container *ngIf="deviceDetail.type == 20">

            <mat-form-field class = "full-width">
                <mat-label translate>device.field.counterName</mat-label>
                <input [(ngModel)]="deviceDetail.counterName" matInput>
            </mat-form-field>

        </ng-container>

        <!-- ------------------------------------------------------------------------  -->
        
        <ng-container *ngIf="deviceDetail.type == 30">

            <mat-checkbox [(ngModel)]="deviceDetail.beep" class = "full-width mr-3">
                <span translate>device.field.beep</span>
            </mat-checkbox>

        </ng-container>        

        <!-- ------------------------------------------------------------------------  -->
        
        <ng-container *ngIf="deviceDetail.type == 30">

            <mat-checkbox [(ngModel)]="deviceDetail.speech" class = "full-width">
                <span translate>device.field.speech</span>
            </mat-checkbox> 
                 
        </ng-container>

        <!-- ------------------------------------------------------------------------  -->
        
        <ng-container *ngIf="deviceDetail.type == 30 && deviceDetail.speech == 1">

            <mat-form-field class = "full-width mt-3">
                <mat-label translate>device.field.speechMessage</mat-label>
                <input [(ngModel)]="deviceDetail.speechMessage" required matInput>
            </mat-form-field>

        </ng-container>

         <!-- ------------------------------------------------------------------------  -->
        
         <ng-container *ngIf="deviceDetail.type == 30 && deviceDetail.speech == 1">

            <mat-form-field class = "full-width mb-3">
                <mat-label translate>device.field.speechCounter</mat-label>
                <input [(ngModel)]="deviceDetail.speechCounter" required matInput>
            </mat-form-field>

         </ng-container>

        <!-- ------------------------------------------------------------------------  -->

        <ng-container *ngIf="isHubManager() && (deviceDetail.type == 10 || deviceDetail.type == 30)">

            <br>
            <mat-checkbox [(ngModel)]="advanced" class = "full-width mr-3 mt-3">
                <span translate>device.field.advanced</span>
            </mat-checkbox>        
                
        </ng-container>

        <!-- ------------------------------------------------------------------------  -->

        <ng-container *ngIf="advanced == 1 && (deviceDetail.type == 10 || deviceDetail.type == 30)">

            <mat-form-field class = "full-width">
                <mat-label translate>device.field.configurationJson</mat-label>
                <textarea matInput [(ngModel)] = "deviceDetail.configurationJson"></textarea>
            </mat-form-field>

        </ng-container>

        <!-- ------------------------------------------------------------------------  -->

        <ng-container *ngIf="deviceDetail.dateLicensed">

            <mat-form-field class = "full-width mt-3">
                <mat-label translate>device.field.dateLicensed</mat-label>
                <input [(ngModel)]="deviceDetail.dateLicensed" matInput disabled>
            </mat-form-field>

        </ng-container>

        <!-- ------------------------------------------------------------------------  -->
        
        <mat-form-field class = "full-width">
            <mat-label translate>device.field.notes</mat-label>
            <input matInput [(ngModel)] = "deviceDetail.notes">
        </mat-form-field>

        <!-- ------------------------------------------------------------------------  -->

        <ng-container *ngIf="deviceDetail.open && deviceDetail.type == 20">

            <span translate>device.field.open</span>
            <span translate>{{ getOpen() }}</span>
            <br>

        </ng-container>

        <!-- ------------------------------------------------------------------------  -->

        <mat-checkbox [(ngModel)]="deviceDetail.enabled" class = "full-width mr-3">
            <span translate>device.field.enabled</span>
        </mat-checkbox>        

        <!-- ------------------------------------------------------------------------  -->
    </div>

    <div class="card-footer">
        <button class="btn btn-outline-secondary float-right" (click) = "save()" translate>device.action.save</button>
        
        <ng-container *ngIf="action == 'create'">
            <button class="btn btn-outline-danger float-right mr-3" (click) = "cancel()" translate>device.action.cancel</button>
        </ng-container>
    </div>

</div>
